// extracted by mini-css-extract-plugin
export default {"deviceTitle":"view-device-modal_deviceTitle__4gy6p","deviceValue":"view-device-modal_deviceValue__vuOtK","socket":"view-device-modal_socket__KtAx-"};